/**
 * Padding, který je použit při horizontal nebo vertical stretch,
 * aby byl vpravo resp. dole nějaký padding(25px je hodnota použitá na SL.)
 */
export const FIT_TO_CONTENT_MARGIN = 25;
